'use client';

import { useState } from 'react';

import { Avatar, AvatarProps, ImageSize } from './avatar.component';

import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import defaultClinicSvg from '@/assets/avatars/default-clinic.svg?url';
import defaultBranchAvatarSvg from '@/assets/avatars/default-branch-avatar.svg?url';
import defaultProfessionalSvg from '@/assets/avatars/default-professional.svg?url';
import defaultLaboratorySvg from '@/assets/avatars/default-laboratory.svg?url';

export interface EntityAvatarProps extends Omit<AvatarProps, 'src'> {
  src?: string | null;
  size?: ImageSize;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  type: EntityTypeEnum;
  shouldAddLightbox?: boolean;
}

function getDefaultSrc(type: EntityTypeEnum): string {
  switch (type) {
    case EntityTypeEnum.CLINIC:
      return defaultClinicSvg;
    case EntityTypeEnum.BRANCH:
      return defaultBranchAvatarSvg;
    case EntityTypeEnum.PROFESSIONAL:
      return defaultProfessionalSvg;
    case EntityTypeEnum.LABORATORY_COLLECT_POINT:
      return defaultLaboratorySvg;
    default:
      throw new Error('Invalid type provided to PartnerAvatar component');
  }
}

export function EntityAvatar(props: EntityAvatarProps) {
  const { src, type, shouldAddLightbox = false, size = 'xl', onError, ...restProps } = props;
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  const hasImage = !!src && src !== failedSrc;

  const handleError: AvatarProps['onError'] = (event) => {
    if (hasImage) {
      setFailedSrc(src);
    }
    onError?.(event);
  };

  return (
    <Avatar
      size={size}
      src={hasImage ? src : getDefaultSrc(type)}
      shouldAddLightbox={hasImage && shouldAddLightbox}
      onError={handleError}
      {...restProps}
    />
  );
}
